var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryLeadership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 22,
    viewBox: "0 0 48 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1308 0.741811L16.5203 12.3524C16.5203 12.3524 16.4688 12.373 16.4482 12.3524L12.3534 8.25756C12.3534 8.25756 12.302 8.23699 12.2814 8.25756L0.151248 20.3877C-0.17284 20.7118 0.0586486 21.2674 0.516487 21.2674H47.4835C47.9413 21.2674 48.1728 20.7118 47.8488 20.3877L28.2029 0.741811C28.2029 0.741811 28.1514 0.721234 28.1308 0.741811ZM9.64753 19.2045H4.36953C4.32324 19.2045 4.30266 19.1479 4.33352 19.1171L12.2865 11.1641C12.2865 11.1641 12.338 11.1435 12.3586 11.1641L15.0336 13.8391L9.68869 19.184C9.68869 19.184 9.66811 19.1994 9.65268 19.1994L9.64753 19.2045ZM34.3451 14.4821C34.0827 14.4821 33.8204 14.3792 33.6197 14.1786L28.208 8.76684C28.208 8.76684 28.1566 8.74627 28.136 8.76684L22.7242 14.1786C22.2818 14.621 21.541 14.5747 21.1552 14.0448C20.8569 13.6282 20.9443 13.0469 21.3044 12.6816L28.1308 5.8552C28.1308 5.8552 28.1823 5.83462 28.2029 5.8552L35.019 12.6765C35.4048 13.0623 35.4768 13.7002 35.1219 14.1169C34.9161 14.3586 34.628 14.477 34.3399 14.477L34.3451 14.4821Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryLeadership);
export default __webpack_public_path__ + "static/media/CategoryLeadership.d6828615c7648de41dd663bb66e8b84d.svg";
export { ForwardRef as ReactComponent };